module.exports = __webpack_public_path__ + "static/media/Aqi-VeryUnhealthy.385b4c65.png";